<template>
<div class="wrapper">
  <el-card style="margin-bottom: 15px;">
    <admin-title :title="$route.meta.name"></admin-title>
    <el-form ref="form" inline :model="searchData" label-width="">
      <el-form-item label="名称">
        <el-input v-model.trim="searchData.title" placeholder="请输入" clearable class="w-px-180" size="small"></el-input>
      </el-form-item>
      <el-form-item label="日期">
        <el-date-picker size="small" v-model="searchData.date" type="date" placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="员工">
        <el-select v-model="searchData.manager_id" size="small">
          <el-option v-for="item in treeDept" :key="item.id" :label="item.account" :value="item.id" />
        </el-select>

      </el-form-item>
      <el-form-item label=" ">
        <el-button type="primary" size="mini" icon="el-icon-search" @click="serach">搜索
        </el-button>
        <el-button type="info" size="mini" icon="el-icon-refresh" @click="reset">重置
        </el-button>
      </el-form-item>
    </el-form>
  </el-card>
  <el-card style="padding-bottom: 30px;">
    <!-- list -->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部锁单" name="all"></el-tab-pane>
    </el-tabs>
    <el-table :data="list" @selection-change="handleSelectionChange">
      <el-table-column prop="title" label="名称" align="center">
      </el-table-column>
      <el-table-column prop="manager" label="锁单员工" align="center" min-width="120">
        <template slot-scope="{ row }">
          {{ row.manager?.account || '-'}}
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="锁单时间" align="center">
      </el-table-column>
      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-link type="danger" :underline="false" v-if="row.is_can_del" @click="handleDel(row)">删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" :page.sync="searchData.page" :limit.sync="searchData.page_size" @pagination="getList" />
  </el-card>


  <!-- 新增编辑 -->
  <el-dialog :title="formData.id ? '编辑' : '新增'" :visible.sync="show_update" width="width">
    <el-form ref="form" :model="formData" label-width="140px">
      <el-form-item label="标讯名称：" prop="title" :rules="rules">
        <el-input style="width: 450px" v-model="formData.title" size="small" placeholder="请输入" clearable></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="show_update = false" size="small">取 消
      </el-button>
      <el-button type="primary" @click="save" size="small">确 定
      </el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import {
  pageAPI,
  addAPI,
  editAPI,
  delAPI,
  editDisplayAPI,
  treeDeptWithUserAPI
} from "./api"
import { authBtnMixin } from "@/mixins/authBtnMixin"
import UploadImg from "@/components/qiniu-uploader/uploader-img.vue";
import dayjs from 'dayjs';

export default {
  name: 'Index',
  mixins: [authBtnMixin],
  data() {
    return {
      rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
      searchData: {
        page: 1,
        page_size: 30,
        title: '',
        data_type: 'all',
        date: '',
        manager_id: '',
        manager_ids: []
      },
      formData: {
        id: 0,
        title: '',
      },
      activeName: 'all',
      tableIdarr: [],
      show_update: false,
      total: 0,
      detail: {},
      list: [],
      treeDept: []
    }
  },

  mounted() {
    this.getList()
    this.initData()
  },
  methods: {
    handleClick(tab) {
      this.searchData.data_type = tab.name
      this.getList()
    },
    // 更新 display
    modifyDisplay(row) {
      const param = {
        is_display: row.is_display,
        id: row.id
      }
      editDisplayAPI(param).then(response => {
        this.$message.success("操作成功")
        this.getList()
      }).catch(() => {
        this.$message.error(response.message)
      })
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData)
      this.getList()
    },
    // 新增
    goAdd() {
      this.show_update = true
      this.formData = {
        id: 0,
        title: '',
        is_display: 20,
        position: null,
        content: '',
        push_datetime: null
      }
    },
    // 编辑
    goEdit(row) {
      this.show_update = true
      this.formData = {
        id: row.id,
        title: row.title,
        icon: row.icon,
        sort: row.sort,
        is_display: row.is_display,
        page_path: row.page_path,
      }
    },
    // 新增 、编辑 保存
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.formData.id) {
            editAPI(this.formData).then(() => {
              this.$message.success('编辑成功')
              this.show_update = false
              this.getList()
            })
          } else {
            addAPI(this.formData).then(() => {
              this.$message.success('添加成功')
              this.show_update = false
              this.getList()
            })
          }
        }
      })
    },
    // 删除
    handleDel({ id }) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delAPI(id).then(() => {
            this.getList()
            this.$message({
              type: "success",
              message: "删除成功!",
            })
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },
    async serach() {
      await this.getList()
    },
    // 列表
    async getList() {
      const params = { ...this.searchData }
      const res = await pageAPI(params)
      this.list = res.data
      this.total = res.total
    },


    async initData() {
      this.treeDept = await treeDeptWithUserAPI()
    },

    // 列表选中回调事件
    handleSelectionChange(list) {
      this.tableIdarr = []
      if (list.length > 0) {
        for (const item of list) {
          this.tableIdarr.push(item.id)
        }
      }
    },
    // 动态控制选择框是否可选
    selectable(row) {
      console.log(row)
      return row.status === 0 // 根据状态来决定是否禁用选择框
    },

  }
}
</script>

<style lang="scss" scoped>
.wrapper ::v-deep {
  width: 100%;
  padding-bottom: 50px;

  .el-drawer {
    .el-drawer__header {
      font-weight: 700;
      font-size: 20px;
    }
  }
}
</style>
